<template>
  <div>
    <overwatchLoader id='loader' v-if='!site'/>
    <model path="/static/ibis/ibisRatesHorizontalV1/" :content="model" :format='1610'></model>
    <div id='ibisRatesHorizontalV1' class='d-flex flex-column justify-content-around' v-if='site'>
      <div id='master' class='d-flex flex-column justify-content-around'>
        <pageHead :site-name="siteName"></pageHead>
        <div id='main' class='d-flex flex-row justify-content-around'>
          <rates class='left' :ratesLg='ratesLg' :currentLg='currentLg'></rates>
          <services class='right' :servicesLg='ratesLg' :currentLg='currentLg'></services>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './header'
import Rates from './rates/rates'
import Services from './services/services'
import OverwatchLoader from '../../../../loader/overwatch'
import Change from './right/change/change'
import Hosts from './right/hosts/hosts'
import Messages from './right/messages/messages'
import model from '../../../../debug/model'

export default {
  name: 'IbisRatesHorizontalV1',
  components: {
    pageHead: Header,
    rates: Rates,
    services: Services,
    change: Change,
    hosts: Hosts,
    messages: Messages,
    OverwatchLoader,
    model
  },
  data: function () {
    return {
      rightOrder: ['change', 'hosts', 'messages'],
      model: ['Ibis hotels_tarifs_sur tablette_V1a.jpg', 'Ibis hotels_tarifs_sur tablette_V1b.jpg'],
      rightIndex: -1,
      msgCurrentPage: 1,
      goNextComponent: true,
      currentLg: 'lg1',
      lgTimeout: null
    }
  },
  mounted () {
    this.$dm.getData(this.$route) // get data on start
  },
  computed: {
    ratesLg () {
      let rates = this.site && this.site.get('rates')
      if (rates) {
        let data = rates.get('data')
        if (data) {
          return {
            lg1: data[data.languages[0].id],
            lg2: data.languages[1] && data[data.languages[1].id]
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    netStatus () {
      return this.$store.state.connected
    },
    site () {
      let site = this.$store.getters.site
      console.log('site()', site)
      return site
    },
    user () {
      return this.$store.getters.user
    },
    device () {
      return this.$store.getters.device
    },
    siteName () {
      try {
        return this.site.get('rates').get('data').siteName
      } catch (e) {
        return ''
      }
    },
    page () {
      return this.$route.query.page
    },
    transitionName () {
      if (this.page) {
        return 'off' // no transition if page is forced
      } else {
        return 'fade'
      }
    }
  },
  watch: {
    netStatus (newStatus, oldStatus) {
      console.log('netStatus update', oldStatus, newStatus)
      // Get data on connection status change
      if (oldStatus) { // getData must not be done the first time
        console.log('netStatus getdata')
        this.$dm.getData(this.$route)
      }
    },
    user (newUser, oldUser) {
      console.log('User update', oldUser, newUser)
      // Get data when user is logged
      if (oldUser && newUser) {
        console.log('user getdata')
        this.$dm.getData(this.$route)
      }
    },
    device (newDevice, oldDevice) {
      console.log('Device update', oldDevice, newDevice)
      // refresh data on device update
      if (oldDevice && oldDevice._objCount && newDevice) {
        console.log('device getdata')
        this.$dm.getData(this.$route)
      }
    },
    site (newSite, oldSite) {
      console.log('Site updated', oldSite, newSite)
    },
    ratesLg (newRates, oldRates) {
      this.alternates()
    }
  },
  methods: {
    alternates () {
      if (this.ratesLg && this.ratesLg.lg2) {
        if (this.currentLg === 'lg2') {
          this.currentLg = 'lg1'
        } else {
          this.currentLg = 'lg2'
        }
        if (this.lgTimeout) {
          clearTimeout(this.lgTimeout)
        }
        this.lgTimeout = setTimeout(this.alternates, 7000)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
$srcWidth : 1920;
$srcHeight : 1200;
@import "../../../_ibis.scss";

#ibisRatesHorizontalV1 {
  width: 160vh; // https://www.alsacreations.com/article/lire/1490-comprendre-le-viewport-dans-le-web-mobile.html
  height: 100vh;
  background-color: white;
  
  #master {
    position: relative;
    width: 160vh;
    height: 100vh;
    // border: 1px solid black

    #main {
      @include heightPercent(977);

      .left {
        @include widthPercent(967);
        margin-left: 0.9vh;
      }

      .right {
        @include widthPercent(815);
      }
    }
  }
}

</style>

<style lang='scss'>
@import "../../../_ibis.scss";
@import "../../../../../../scss/global.scss";

#app {
  @extend .gradientBackground;
}

#ibisRatesHorizontalV1 .lg1 {
  color: $grey;
}
</style>


// WEBPACK FOOTER //
// src/components/ibis/rates/horizontal/v1/ibisRatesHorizontalV1.vue